module.exports = __webpack_public_path__ + "static/media/item-row-purple.8ef9c997.png";